import Address from './address';
import SchoolArrangement from './schoolArrangement';
import ChildIdentity from './childIdentity';
import CustodyArragement from './custodyArragement';
import EmergencyContact from './emergencyContact';
import PickupPerson from './pickupPerson';
import ChildVaccinationDate from './childVaccinationDate'; 
import ChildLanguage from './childLanguage';
import DeviceLocation from './deviceLocation';
import Disease from './disease';
import Allergen from './allergen';
import SkinProduct from './skinProduct';
import FeedingArragement from './feedingArragement';
import PhysicalRequirement from './physicalRequirement';
import SleepArragement from './sleepArragement';

export default class Child implements ChildIdentity {
    public id: string = "";
    public firstName: string = "";
    public lastName: string =""
    public prefferedName: string ="";
    public age: number = 0;
    public dateOfBirth: string =""
    public ageGroupId: number = 0; 
    public homeAddressId?: string = ""; 
    public custodyArragementId?: string ="";
    public additionalInfo?: string = "";
    public additionalEmergencyInfo?: string = "";
    public requiresAdditionalSupport: boolean = false;
    public hasLifeThretheningAllergy: boolean = false;
    public allergyDetails: string = ""; 
    public schoolArrangement: SchoolArrangement|null = null;
    public custodyArrangement: CustodyArragement|null = null;
    public emergencyContacts: Array<EmergencyContact>|null= null;
    public pickupPersons: Array<PickupPerson>|null =null;
    public childrenVaccinationDates:Array<ChildVaccinationDate>|null = null;
    public medicalDevicesLocations:Array<DeviceLocation> = [];
    public diseases:Array<Disease> = []; 
    public allergens:Array<Allergen>|null = null;
    public skinProducts:Array<SkinProduct>|null = null;
    public feedingArrangement: FeedingArragement|null = null;
    public physicalRequirements:PhysicalRequirement|null = null;
    public childAddress:Address|null = null;
    public enrollmentStepsCompleted:number =0;
    public childLanguages: Array<ChildLanguage> = new Array<ChildLanguage>();
    public sleepArrangement = new SleepArragement();
    public currentViewedStep = 0;
    public subsidy = false;
    public specialNeeds = false;
    public sex = 1;
    public homeAddressSameAsParent: null | boolean = null;
}